import React, { useState } from "react";
import Button from "../Button";
import Icon from "../Icon";
import Overlay from "../Overlay";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { onImageExtensionExist } from "../../helpers/CommonHelpers";
import Document from "../Document";
import { S3BucketConfig } from "../../common/constants";

const FaqsRepeater = ({
  onEdit,
  onDelete,
  faqs,
  user,
  hideActions,
  onClick,
  onImageClicked,
}) => {
  const [pdfUrl, setPdfUrl] = useState("");
  const [statusPdf, setStatusPdf] = useState(false);
  const role = user.roles[0].role.name;
  const hideFaqActions =
    role === "Home Owner" || role === "Strata Manager" || role === "Realtor";

  const fileIcon = (url) => {
    if (url.match(/(.mp4)/gi) !== null) return "video";
    if (url.match(/(.pdf)/gi) !== null) return "file-pdf";
    return "file-download";
  };

  const setPdf = () => {
    setStatusPdf(false);
  };
  const openIframe = (url) => {
    if (url) {
      if (statusPdf === false) {
        setPdfUrl(url);
        setStatusPdf(true);
      }
    } else {
      setStatusPdf(false);
      toast.success("No image to preview.", {
        autoClose: 10000,
        position: "top-center",
      });
    }
  };
  const imageViewer = (img) => {
    if (onImageExtensionExist(img)) {
      return (
        <img
          src={pdfUrl}
          alt=""
          style={{ display: "flex", width: "auto", height: "90%" }}
        />
      );
    } else {
      return (
        <>
          <iframe
            src={
              "https://docs.google.com/gview?url=" + pdfUrl + "&embedded=true"
            }
            style={{ overflow: "hidden", height: "90%", width: "100%" }}
          ></iframe>
        </>
      );
    }
  };
  return (
    <div>
      {faqs.map((faq, x) => (
        <div key={x} className="faqs__faq">
          {hideActions && (
            <div className="faqs__question" style={{ marginBottom: 5 }}>
              {faq?.itemName}
            </div>
          )}
          <div className="faqs__question">
            {faq.question}
            {!hideFaqActions ? (
              hideActions && faq.faqType === "Item" ? null : (
                <div className="faqs__actions">
                  <Button
                    color="semantic"
                    onClick={() => onEdit(faq)}
                    label={<Icon glyph="pencil" weight="light" />}
                  />
                  <Button
                    color="semantic"
                    onClick={() => onDelete(faq)}
                    label={<Icon glyph="trash" weight="light" />}
                  />
                </div>
              )
            ) : null}
          </div>
          <div className="faqs__answer">
            {<div dangerouslySetInnerHTML={{ __html: faq.answer }} />}
          </div>
          <div className="faqs__answer">{faq.linkTitle}</div>
          <div className="faqs__details">
            <div className="faqs__category">{faq.issue}</div>
          </div>
          {faq.uploadType === "Image" && faq.image && (
            <div
              className="faqs__link-title"
              onClick={() => openIframe(faq.image)}
              style={{ cursor: "pointer", marginTop: 5 }}
            >
              FAQ Document
            </div>
          )}

          <div>
            {faq.Embed && faq.Embed.length > 0 ? (
              <div
                style={{
                  width: "172px",
                  height: "130",
                }}
              >
                <div class="documents__item">
                  <div className="container">
                    <div class="h_iframe">
                      <div
                        style={{ height: "180px" }}
                        dangerouslySetInnerHTML={{ __html: `${faq.Embed} ` }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : faq.uploadType !== "Image" && faq.image ? (
              <div>
                <Document
                  key={x}
                  headline={
                    faq.documentType === "Frequently Asked Questions"
                      ? faq.image && faq.image?.split(S3BucketConfig.url)
                      : faq.name
                  }
                  itemName={faq.itemName}
                  image={faq.image ? faq.image : null}
                  onDownload={() =>
                    faq.image ? onClick(faq.image) : onClick()
                  }
                  onClick={() =>
                    faq.image && faq.type === "Image"
                      ? onImageClicked(x, faq.image)
                      : faq.document && faq.type === "Image"
                      ? onImageClicked(x, faq.document)
                      : null
                  }
                  icon={<Icon glyph={fileIcon(faq.image)} weight="light" />}
                />
              </div>
            ) : null}{" "}
          </div>
        </div>
      ))}

      <Overlay
        showOverlay={statusPdf}
        content={
          <div
            style={{
              width: "80%",
              margin: "auto",
              padding: "5px",
              height: "90%",
            }}
          >
            <div style={{ padding: "10px" }}>
              <button
                type="button"
                className="form__dismiss"
                style={{ color: "#454F5B" }}
                onClick={() => setPdf()}
              >
                <Icon weight="light" glyph="arrow-left" />
              </button>

              <span
                className="heading-with-details__headline"
                style={{ padding: "0px 50px" }}
              >
                FAQ Document
              </span>
            </div>
            {imageViewer(pdfUrl)}
          </div>
        }
      ></Overlay>
    </div>
  );
};

export default FaqsRepeater;
